function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import get from 'lodash/get';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import Cookies from 'universal-cookie';
import { ApiError } from 'helpers/errorTypes';
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 * @param  {object} options  The fetch options
 *
 * @return {object}          The parsed JSON from the request
 */ function parseJSON(response, options) {
    const json = response.text().then((text)=>text ? JSON.parse(text) : {});
    if (response.status >= 200 && response.status < 300) {
        return json;
    }
    return json.then((resp)=>{
        throw new ApiError({
            url: get(response, 'url'),
            status: get(response, 'status'),
            validationErrors: get(resp, 'validationErrors'),
            businessError: get(resp, 'businessError') || get(resp, 'message'),
            requestId: get(resp, 'requestId'),
            options: omit(pick(options, [
                'method',
                'headers'
            ]), 'headers.Authorization')
        });
    });
}
/**
 * Requests a URL, returning a promise
 *
 * @param  {function} fetch    Fetch function
 * @param  {string} url        The URL we want to request
 * @param  {object} [options]  The options we want to pass to "fetch"
 * @param  {string} [jwtToken] Token we want to use to authorize request instead of the one from cookie
 *
 * @return {object}           The response data
 */ export default function request(fetch, url, options, jwtToken) {
    const cookies = new Cookies();
    const token = jwtToken || cookies.get('token');
    options = _object_spread_props(_object_spread({}, options), {
        headers: _object_spread({}, token ? {
            Authorization: `Bearer ${token}`
        } : null, get(options, 'headers', {}))
    });
    return fetch(url, options)// .then(checkStatus)
    .then((response)=>parseJSON(response, options), (err)=>{
        throw new ApiError({
            url,
            status: 503,
            error: `${err}`,
            validationErrors: {},
            options: omit(pick(options, [
                'method',
                'headers'
            ]), 'headers.Authorization')
        });
    });
}
